{
  "user_list": {
    "navigation_title": "List",
    "details": "User Details",
    "manage_roles": "Manage Roles"
  }
}